module.exports = __webpack_public_path__ + "img/jobs.6113546d.jpg";